// extracted by mini-css-extract-plugin
module.exports = {"sqtl":"Info_sqtl__2FXF_","sqmenu":"Info_sqmenu__saLGR","bodycontent":"Info_bodycontent__3yb6l","pagedata":"Info_pagedata__2y2dO"};